import { useNavigate } from 'react-router-dom';
import { SelectedFilters } from '../../types/filters.type';
import customIcons from '../../utils/icons';
import useFilterStore from '../streetview/filterStore';
import { BenefitRows } from '../../types/global';

export default function BenefitCard({
  title, data, isExpanded, onToggle,
}: { title: string, data: BenefitRows[], isExpanded: boolean;
  onToggle: (id: string) => void;
}) {
  const navigate = useNavigate();
  const { updateFilterStore } = useFilterStore();

  const handleNumberClick = (filters: SelectedFilters) => {
    updateFilterStore(filters);
    navigate('/streetview');
  };

  const row = (rowText: string, value: string, filters?: SelectedFilters) => (
    <div key={rowText} id="benefit-card-row" className="flex flex-col p-2 gap-2 border-t">
      <div className="flex justify-between items-start gap-1">
        <span className="text-xs">
          {rowText}
        </span>
        {filters ? (
          <button
            type="button"
            onClick={() => handleNumberClick(filters)}
            className={`${filters ? 'text-primary underline hover:cursor-pointer' : ''} text-sm`}
          >
            {value}
          </button>
        ) : <span className="text-sm">{value}</span>}

      </div>
    </div>
  );

  const showRows = (rows: BenefitRows[]) => {
    if (rows.length > 2) {
      return (
        <>

          { rows.slice(0, 2).map((summary: { title: string, value: string, filters?: SelectedFilters }) => (
            row(summary.title, summary.value, summary.filters)
          ))}
          <div key={`${title}-details`} className="flex justify-between items-start p-2 gap-2 border-t text-primary">
            <span className="text-xs">
              Details
            </span>
            <button
              type="button"
              onClick={() => onToggle(title)}
              className="text-sm cursor-pointer"
            >
              {customIcons.chevronDown}
            </button>
          </div>
          {isExpanded && rows.slice(2).map((summary: { title: string, value: string, filters?: SelectedFilters }) => (
            row(summary.title, summary.value, summary.filters)
          ))}
        </>
      );
    }
    return rows.map((summary: { title: string, value: string, filters?: SelectedFilters }) => (
      row(summary.title, summary.value, summary.filters)
    ));

    return null;
  };

  return (
    <div id="summary-card-container" className="flex flex-col min-w-[150px] font-normal rounded outline outline-pipgrey-light h-fit">
      <div className="flex justify-between items-start bg-blue-50 p-2 rounded-t-sm">
        <span title={title} className="text-wrap font-bold">{title}</span>
      </div>
      {showRows(data)}
    </div>
  );
}
